import api from "../../Environment";

/**
 * Owner-only account completion API. Both calls are authenticated with the
 * signed-in user's id + token by the shared API helper; date of birth and
 * location are only ever sent to / read from these endpoints.
 */

export async function fetchAccountEligibility() {
  const response = await api.postMethod("account/eligibility", {});
  const body = response && response.data;
  if (body && body.success === true && body.data) {
    return body.data;
  }
  return null;
}

/**
 * @param {{date_of_birth?:string,country_code:string,region_code:string,region_name:string}} payload
 * @returns {Promise<{success:boolean,data?:object,message?:string,errors?:object}>}
 */
export async function saveAccountEligibility(payload) {
  const response = await api.postMethod("account/eligibility/save", payload);
  const body = (response && response.data) || {};
  if (body.success === true) {
    return { success: true, data: body.data || null };
  }
  return {
    success: false,
    message: typeof body.error_messages === "string" ? body.error_messages : "",
    errors: body.errors && typeof body.errors === "object" ? body.errors : {},
  };
}
